import React, {useCallback, useEffect} from 'react';
import i18n from '../../../../../i18n';
import Panel from '../../../../../components/Panel';

import {useDispatch, useSelector} from 'react-redux';
import {layoutActions, layoutSelectors} from '../../../redux';
import {AuthenticationPolicies, IAuthenticationPolicies} from 'types/AuthenticationPolicies';
import FormikCheckbox from '../../../../../components/inputs/FormikCheckbox';
import LastUpdatedLabel from '../../../../../components/LastUpdatedLabel';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {Grid} from '@mui/material';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {GridCentered} from 'components/GridCentered';
import {isEmpty} from 'lodash';
import {IPAccessRuleButton} from 'components/buttons/IPAccessRuleButton';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';
import {DiplomatFeature} from 'types/DiplomatFeature';
import {licenseSelectors} from 'redux/license';

type AuthPoliciesProps = {};

export const AuthPolicies: ReactFChildrenProps<AuthPoliciesProps> = (props) => {
   const dispatch = useDispatch();
   const authPolicies = useSelector(layoutSelectors.authPolicies);
   const isFeatureSupported = useSelector(licenseSelectors.isFeatureSupported);

   useEffect(() => {
      dispatch(layoutActions.getAuthPolicies);
   }, [dispatch]);

   const submit = useCallback(
      (data: IAuthenticationPolicies, formikBag: FormOnSubmitHelpers<IAuthenticationPolicies>) => {
         dispatch(
            layoutActions.postAuthPolicies(data, {
               onSuccess: () => {
                  dispatch(layoutActions.getAuthPolicies);
                  formikBag.setSubmitting(false);
               },
               onError: (errors: any) => formikBag.setErrors(errors),
            })
         );
      },
      [dispatch]
   );

   return (
      <Panel name={i18n.t('Authentication Policies')}>
         {!isEmpty(authPolicies) && (
            <Formik
               initialValues={AuthenticationPolicies.cast(authPolicies) as IAuthenticationPolicies}
               validationSchema={AuthenticationPolicies}
               onSubmit={submit}
               // enableReinitialize
            >
               <>
                  <Grid container spacing={3}>
                     <Grid item xs={4}>
                        <FormikCheckbox
                           autoFocus
                           name="caseInsensitiveAuthentication"
                           label={i18n.t('Ignore case sensitivity for usernames')}
                        />
                     </Grid>
                     <GridCentered item>
                        <IPAccessRuleButton
                           isAdmin
                           text={i18n.t(`IP Access Restrictions allow you to control which IP addresses are allowed to connect to
       the Diplomat MFT Admin Portal. Choose to allow or deny certain IPs.`)}
                        />
                     </GridCentered>
                  </Grid>
                  {isFeatureSupported(DiplomatFeature.SAML_SSO) && (
                     <Grid container spacing={3}>
                        <Grid item xs={4}>
                           <FormikCheckbox
                              autoFocus
                              name="ssoOnly"
                              label={i18n.t('Require SSO for Administrator Login')}
                           />
                        </Grid>
                     </Grid>
                  )}
                  <Grid container spacing={3} justifyContent="center">
                     <Grid item>
                        <FormFooterButtons submitLabel={i18n.t('Save')} resettable />
                     </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                     <Grid item>
                        <LastUpdatedLabel
                           date={authPolicies.timestamp}
                           author={authPolicies.lastUser}
                        />
                     </Grid>
                  </Grid>
               </>
            </Formik>
         )}
      </Panel>
   );
};
